import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../config/axiosInterceptor";

export default function AgreementUpload() {
  const [forType, setForType] = useState("agency");
  const [agreement, setAgreement] = useState(null);
  const [terms, setTerms] = useState(null);
  const [msg, setMsg] = useState("");
  const [existing, setExisting] = useState(null);
  const agreementRef = useRef();
  const termsRef = useRef();

  // Fetch existing docs when forType changes or after upload
  useEffect(() => {
    const fetchExisting = async () => {
      setExisting(null);
      try {
        const res = await axiosInstance.get(`${process.env.REACT_APP_BASEURL1}/admin/kyc/agreement/${forType}`);
        if (res.data.success && res.data.doc) setExisting(res.data.doc);
      } catch (e) {
        setExisting(null);
      }
    };
    fetchExisting();
  }, [forType, msg]);

  const handleUpload = async (e) => {
    e.preventDefault();
    // if (!agreement || !terms) {
    //   setMsg("Both files required");
    //   return;
    // }
    const data = new FormData();

    data.append("forType", forType);
    if(agreement)
    data.append("agreement", agreement);
    if(terms)
    data.append("terms", terms);
    try {
      const res = await axiosInstance.post(`${process.env.REACT_APP_BASEURL1}/admin/kyc/agreementUpload`, data);
      setMsg(res.data.message);
      setAgreement(null);
      setTerms(null);
      if (agreementRef.current) agreementRef.current.value = "";
      if (termsRef.current) termsRef.current.value = "";
    } catch (err) {
      setMsg("Upload failed");
    }
  };

  return (
    <form onSubmit={handleUpload} style={{ maxWidth: 400, margin: "40px auto", background: "#fff", padding: 24, borderRadius: 10 }}>
      <h3>Upload Agreement & Terms</h3>
      <label>For:</label>
      <select value={forType} onChange={e => setForType(e.target.value)} style={{ width: "100%", marginBottom: 12 }}>
        <option value="agency">Agency</option>
        <option value="bd">BD</option>
        <option value="agencyadmin">Agency Admin</option>
        <option value="coinseller">Coin Seller</option>
      </select>
      <label>Agreement PDF:</label>
      <input type="file" accept="application/pdf" ref={agreementRef} onChange={e => setAgreement(e.target.files[0])} />
      <label>Terms & Conditions PDF:</label>
      <input type="file" accept="application/pdf" ref={termsRef} onChange={e => setTerms(e.target.files[0])} />
      <button type="submit" style={{ marginTop: 16, background: "#3576f6", color: "#fff", border: "none", borderRadius: 6, padding: "8px 18px", fontWeight: 600, cursor: "pointer" }}>Upload</button>
      {msg && <div style={{ marginTop: 12, color: "#3576f6" }}>{msg}</div>}

      {/* Show existing docs if present */}
      {existing && (
        <div style={{ marginTop: 24, background: "#f6f9fc", padding: 16, borderRadius: 8 }}>
          <div style={{ fontWeight: 600, marginBottom: 8 }}>Already Uploaded Documents:</div>
          <div>
            <b>Agreement:</b>{" "}
            <a href={`${process.env.REACT_APP_BASEURL1}/${existing.agreementPath.replace(/\\/g, "/")}`} target="_blank" rel="noopener noreferrer">
              View PDF
            </a>
          </div>
          <div>
            <b>Terms & Conditions:</b>{" "}
            <a href={`${process.env.REACT_APP_BASEURL1}/${existing.termsConditionPath.replace(/\\/g, "/")}`} target="_blank" rel="noopener noreferrer">
              View PDF
            </a>
          </div>
          <div style={{ fontSize: 13, color: "#888", marginTop: 4 }}>
            Uploaded At: {existing.updatedAt ? new Date(existing.updatedAt).toLocaleString() : "-"}
          </div>
        </div>
      )}
    </form>
  );
}